// ───────── Formatters ─────────

export const formatNumber = (v, decimals = 0) => {
  const num = Number(v)
  if (!isFinite(num)) return "—"
  return new Intl.NumberFormat("es-CO", {
    minimumFractionDigits: decimals, maximumFractionDigits: decimals,
  }).format(num)
}

export const formatPercent = (v, decimals = 2) => {
  const num = Number(v)
  if (!isFinite(num)) return "—"
  return `${num.toFixed(decimals)}%`
}

export const formatFecha = iso => {
  if (!iso) return "—"
  try {
    const s = String(iso).substring(0, 10)
    const [y, m, d] = s.split("-")
    if (y && m && d) return `${d}/${m}/${y}`
    return iso
  } catch { return iso }
}

export const formatFechaHora = iso => {
  if (!iso) return "—"
  const s = String(iso).replace("T", " ").substring(0, 19)
  return s
}

export const formatGrowth = v => {
  const num = Number(v)
  if (!isFinite(num)) return { text: "—", color: "#64748b", icon: "minus" }
  const text = `${num > 0 ? "+" : ""}${num.toFixed(1)}%`
  if (num > 0) return { text, color: "#10b981", icon: "trending-up" }
  if (num < 0) return { text, color: "#ef4444", icon: "trending-down" }
  return { text, color: "#64748b", icon: "minus" }
}

// Rango YYYY-MM-DD HH:mm:ss (formato que espera el back: con espacio)
export const buildRangoTimestamp = (fechaInicio, fechaFin) => {
  if (!fechaInicio || !fechaFin) return {}
  return {
    desde: `${fechaInicio} 00:00:00`,
    hasta: `${fechaFin} 23:59:59`,
  }
}

export const rangoDelMes = (year, month) => {
  const yyyy = String(year)
  const mm = String(month).padStart(2, "0")
  const ultimo = new Date(year, month, 0).getDate()
  const fi = `${yyyy}-${mm}-01`
  const ff = `${yyyy}-${mm}-${String(ultimo).padStart(2, "0")}`
  return {
    fecha_inicio: fi,
    fecha_fin: ff,
    desde: `${fi} 00:00:00`,
    hasta: `${ff} 23:59:59`,
  }
}

// ───────── Paleta de estados de envío ─────────

export const ESTADO_CONFIG = {
  pending:      { color: "#64748b", bg: "#f1f5f9", label: "Pendiente",       icon: "fa-clock" },
  processing:   { color: "#0284c7", bg: "#e0f2fe", label: "Procesando",      icon: "fa-sync" },
  sent_full:    { color: "#16a34a", bg: "#dcfce7", label: "Enviado",         icon: "fa-check-circle" },
  sent_partial: { color: "#ca8a04", bg: "#fef9c3", label: "Enviado parcial", icon: "fa-check" },
  failed:       { color: "#dc2626", bg: "#fee2e2", label: "Fallido",         icon: "fa-times-circle" },
  definitivo:   { color: "#7f1d1d", bg: "#fee2e2", label: "Definitivo",      icon: "fa-ban" },
  skipped:      { color: "#475569", bg: "#e2e8f0", label: "Omitido",         icon: "fa-forward" },
}

export const estadoConfig = e => {
  const k = String(e || "").toLowerCase()
  return ESTADO_CONFIG[k] || { color: "#64748b", bg: "#f1f5f9", label: e || "—", icon: "fa-question-circle" }
}

// ───────── Paleta de bounces ─────────

export const BOUNCE_CONFIG = {
  HardBounce:   { color: "#dc2626", bg: "#fee2e2", label: "Hard bounce" },
  SoftBounce:   { color: "#f97316", bg: "#ffedd5", label: "Soft bounce" },
  Permanent:    { color: "#7f1d1d", bg: "#fee2e2", label: "Permanente" },
  Transient:    { color: "#f59e0b", bg: "#fef3c7", label: "Transitorio" },
  Undetermined: { color: "#64748b", bg: "#f1f5f9", label: "Indeterminado" },
}

export const bounceConfig = b => {
  const k = String(b || "")
  return BOUNCE_CONFIG[k] || { color: "#64748b", bg: "#f1f5f9", label: b || "—" }
}

// ───────── Paleta general para gráficos ─────────

export const PALETA = [
  "#3b82f6", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6",
  "#06b6d4", "#ec4899", "#84cc16", "#f97316", "#6366f1",
]
export const colorPara = i => PALETA[i % PALETA.length]
